/** 回饋項目 - 機場禮遇 - 子分類選項 */
export enum RewardApprSecondCategory {
  /** 貴賓室 */
  LOUG = 'LOUG',
  /** 超額行李 */
  PDBG = 'PDBG',
  /** 優先劃位櫃檯 */
  PRCK = 'PRCK',
  /** 優先登機 */
  PRBD = 'PRBD',
  /** 優先裝卸行李 */
  PRBG = 'PRBG'
}
